import styled, { css } from 'styled-components';
import classNames from 'classnames';

export interface Props {
  /**
   * @default 'normal'
   */
  size?: string;
  /**
   * @default "green"
   */
  colour?: string;
  className?: string;
  domain?: string;
}

const dotSelector = ({ size, colour }: Pick<Props, 'size' | 'colour' | 'domain'>) => {
  switch (size) {
    case 'normal': {
      let colourPosition;
      switch (colour) {
        case 'green':
          colourPosition = '-5px';
          break;
        case 'blue':
          colourPosition = '25px';
          break;
        case 'red':
          colourPosition = '-35px';
          break;
        default:
          colourPosition = '0';
      }

      return css`
        background-image: url('https://res.cloudinary.com/fxtr/image/upload/v1656437008/landing/icons/sprite_large_gbhyvi.png');
        height: 20px;
        background-size: 30px;
        background-position: 0 ${colourPosition};
      `;
    }
    case 'small': {
      let colourPosition;
      switch (colour) {
        case 'green':
          colourPosition = '30px';
          break;
        case 'blue':
          colourPosition = '8px';
          break;
        case 'red':
          colourPosition = '20px';
          break;
        default:
          colourPosition = '8px';
      }
      return css`
        background-image: url('https://res.cloudinary.com/fxtr/image/upload/v1623679518/landing/icons/sprite_olftcj.png');
        height: 7px;
        background-size: 20px;
        background-position: 0 ${colourPosition};
      `;
    }
    default:
      return '';
  }
};

const StyledDot = styled.div<Props>`
  display: block;
  background-repeat: repeat;
  width: 100%;
  ${dotSelector}
`;

export function DotLine({ size = 'normal', colour = 'green', className, ...props }: Props): JSX.Element {
  return <StyledDot className={classNames('DotLine', className)} size={size} colour={colour} {...props} />;
}
DotLine.displayName = 'DotLine';
